export default "__VITE_ASSET__56c529e9__"